import { call, put } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import { completeScanSteps } from '../api';
import { completeScanStepsFailure, completeScanStepsSuccess } from '../actions';

export function* completeScanStepsSaga(action: any) {
  try {
    const { organisationId } = action.payload;
    const response = yield call(completeScanSteps, organisationId);

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(completeScanStepsSuccess(organisationId));
  } catch (error) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(completeScanStepsFailure());
  }
}
